import { render, staticRenderFns } from "./ReportRefferal.vue?vue&type=template&id=0ceaabb4&"
import script from "./ReportRefferal.vue?vue&type=script&lang=js&"
export * from "./ReportRefferal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports